import { ILink } from '../models/navigation';
import { routes } from '../constants/routes';

export const useAccountCrumbs = (additionalCrumbs: ILink[] = []): ILink[] => {
  return [{ path: '/', label: 'Home' }, routes.dashboard, ...additionalCrumbs];
};
